import React, { useEffect } from 'react';
import {
  FiLock,
  FiShield,
  FiLink,
  FiUsers,
  FiRefreshCw,
  FiMail
} from 'react-icons/fi';
import halfRound from '../assets/images/half_round.png';

const policyItems = [
  {
    icon: FiLock,
    title: 'Information Collection and Use',
    text: (
      <>
        DI Labs does not collect, store, or share any personal information. Our apps are designed to work entirely on your device, and we do not require account creation, registration, or any personal details to use our services. Any data or content created within the apps (such as mirror displays or media) remains on your device and is not transmitted to us or any third party.
      </>
    )
  },
  {
    icon: FiShield,
    title: 'No Cookies or Tracking',
    text: (
      <>
        We do not use cookies, analytics tools, or tracking technologies of any kind. Our apps do not collect any usage data, device information, or behavioral data. Your experience is 100% private and stays on your device.
      </>
    )
  },
  {
    icon: FiLink,
    title: 'Third-Party Links',
    text: (
      <>
        Our apps may contain links to third-party websites or services. We are not responsible for the privacy practices or content of those external sites. We encourage you to review their privacy policies before providing any information.
      </>
    )
  },
  {
    icon: FiUsers,
    title: "Children's Privacy",
    text: (
      <>
        Our apps are not directed to children under the age of 13. We do not knowingly collect any information from children. If you believe a child has provided us with information, please contact us.
      </>
    )
  },
  {
    icon: FiRefreshCw,
    title: 'Changes to This Privacy Policy',
    text: (
      <>
        We may update this Privacy Policy from time to time. Any changes will be reflected on this page with an updated Effective Date. We encourage you to review this policy periodically.
      </>
    )
  },
  {
    icon: FiMail,
    title: 'Contact Us',
    text: (
      <>
        If you have any questions or concerns about this Privacy Policy,
        <br />
        please contact us at:
        <br />
        <strong>Email:</strong>{' '}
        <a href="mailto:support@dilabs.com" className="privacy-email">support@dilabs.com</a>
      </>
    )
  }
];

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <main className="privacy-page">
      <div className="home-hero-round-bg">
        <img src={halfRound} alt="" className="home-hero-round-img" />
      </div>

      <div className="privacy-container">
        <header className="privacy-heading-wrap">
          <span className="privacy-badge">Your Privacy. Our Priority.</span>
          <h1 className="privacy-main-heading">Privacy Policy</h1>
        </header>

        <article className="privacy-content">
          <div className="privacy-content-header">
            <h2 className="privacy-section-title">Privacy Policy for DI Labs</h2>
            <p className="privacy-date"><strong>Effective Date:</strong> May 15, 2024</p>
          </div>
          <p className="privacy-introduction">
            At DI Labs, we value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we handle information when you use our apps.
          </p>

          <div className="privacy-list">
            {policyItems.map(({ icon: Icon, title, text }, index) => (
              <section className="privacy-policy-item" key={title}>
                <div className="privacy-icon" aria-hidden="true">
                  <Icon />
                </div>
                <div className="privacy-item-copy">
                  <h3 className="privacy-subtitle">{index + 1}. {title}</h3>
                  <p className="privacy-text">{text}</p>
                </div>
              </section>
            ))}
          </div>
        </article>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
